export enum Filter {
  Active = "Active Employees",
}
